<template>
  <div class="modal fade" id="defaultMsgModal" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content default-modal-content">
        <div class="modal-header">
          <div class="card text-center">
            <div class="card-body">
              <img src="../../../public/static/images/icons/expiry.svg" class="expiry_logo card-img-top" alt="expiry-icon"/>
              <div class="default-message pb-0">
                <p class="" v-if="defaultMessage && defaultMessage.message">{{defaultMessage.message}}</p>
              </div>
              <div class="default-message">
                <span class="" v-if="defaultMessage && defaultMessage.show_link && isDashboardCustomizable">
                  Please <a class="cursor-pointer" @click="redirect()">click here</a> to customize your dashboard under Account Settings -> Preferences
                </span>
                <span class="" v-if="defaultMessage && defaultMessage.show_link && !isDashboardCustomizable">
                  You currently do not have an option to customize your dashboard as you are not subscribed to any Premium services
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 ok-btn">
                <button
                  class="btn btn-block emergo-blue-button"
                  @click="submitModal"
                >OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';

export default {
  props: ['defaultMessage', 'isDashboardCustomizable'],
  methods: {
    submitModal() {
      $('#defaultMsgModal').modal('hide');
    },
    redirect() {
      EventBus.$emit('notificationSettings', 'dashboard');
      this.submitModal();
    },
  },
  watch: {
    defaultMessage() {
      if (this.defaultMessage && this.defaultMessage != null) {
        $('#defaultMsgModal').modal('show');
      }
    },
  },
};
</script>

<style scoped>
.modal .modal-dialog .modal-content {
  border-radius: 10px;
}
.modal .modal-dialog .modal-content .modal-header {
  background: #f2f2f2;
  border-radius: 10px;
}
img.expiry_logo.card-img-top {
    width: 50px;
    height: 50px;
}

.pb-0 {
  padding-bottom: 0px !important;
}
.default-message {
  padding: 25px 20px 25px 20px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
  font-size: 18px;
  font-weight: 300;
}
.ok-btn {
  width: 50%;
  margin: auto;
  float: initial;
}
.default-modal-content {
  max-width: fit-content;
  float: right;
}
</style>
